import BaseApi from './BaseApi'

class HolidaysApi extends BaseApi {
  getAvailableYears (schemaId) {
    return this.get(`employeeHolidays/${schemaId}`)
  }

  getHolidaysByYear (schemaId, year) {
    return this.get(`employeeHolidays/${schemaId}/${year}`)
  }

  setHolidays (schema_id, from, to) {
    return this.post(`employeeHolidays`, { schema_id, from, to })
  }

  deleteHolidays (id) {
    return this.delete(`employeeHolidays`, { id })
  }
}

export default new HolidaysApi()
